exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-flows-interest-invite-___style__inviteContainer___254vQ{text-align:center;border-bottom:1px solid #e5e3e3}.web-flows-interest-invite-___style__inviteContainer___254vQ>img{border-radius:50%;width:85px;height:85px}.web-flows-interest-invite-___style__inviteContainer___254vQ>h3{font-weight:400}.web-flows-interest-invite-___style__login___GEDIT{text-align:center;font-size:1.1em;margin-bottom:0}", ""]);

// exports
exports.locals = {
	"inviteContainer": "web-flows-interest-invite-___style__inviteContainer___254vQ",
	"login": "web-flows-interest-invite-___style__login___GEDIT"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/flows/interest/invite/style.css
// module id = 1357
// module chunks = 0